import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { DESTINATIONS, LINKS } from "@/data/content";

export default function Destinations() {
  return (
    <section id="destinos" data-testid="destinos-section" className="bg-[#F8FAFC] text-[#0F172A] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-[11px] sm:text-xs tracking-[0.35em] text-[#0055FE] mb-5">
            SEU PRÓXIMO CAPÍTULO — ENCONTRE SUA PRÓXIMA VIAGEM
          </p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl max-w-2xl">
            Escolha o destino.{" "}
            <em className="font-serif italic font-medium text-[#FF5A36]">Eu cuido do resto.</em>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 max-w-xl">
            Um mundo de possibilidades. Uma viagem que combina com você.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5">
          {DESTINATIONS.map((d, i) => (
            <Reveal key={d.number} delay={(i % 3) * 0.1} className={`${d.span} md:col-span-1`}>
              <a
                href={LINKS.destino(d.name)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={d.testid}
                className="group relative block h-[380px] sm:h-[420px] rounded-3xl overflow-hidden"
              >
                <img
                  src={d.image}
                  alt={d.name}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120]/90 via-[#0B1120]/25 to-transparent transition-opacity duration-500" />
                <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-white/10 group-hover:ring-[#00E5A3]/60 transition duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-7 flex items-end justify-between gap-4">
                  <div>
                    <span className="font-mono text-xs tracking-[0.3em] text-[#00E5A3]">{d.number}</span>
                    <h3 className="mt-2 font-display font-bold text-white text-xl sm:text-2xl tracking-tight">
                      {d.name}
                    </h3>
                    <p className="mt-2 text-sm text-white/75 max-w-xs leading-relaxed">{d.description}</p>
                  </div>
                  <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-4 py-2 group-hover:bg-[#FF5A36] group-hover:border-[#FF5A36] transition-colors duration-300">
                    Conhecer
                    <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-16">
          <div
            data-testid="missing-destination-cta"
            className="relative overflow-hidden rounded-3xl p-8 sm:p-12"
            style={{ background: "linear-gradient(120deg, #0055FE 0%, #00A3FF 55%, #00E5A3 130%)" }}
          >
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-white/10 blur-2xl" />
            <div className="relative flex flex-col md:flex-row md:items-center md:justify-between gap-8">
              <div className="max-w-xl">
                <h3 className="font-display font-bold text-white text-xl sm:text-2xl tracking-tight">
                  Não encontrou o seu destino?
                </h3>
                <p className="mt-3 text-white/85 text-base leading-relaxed">
                  O mundo é maior que essa lista. Trabalho com outros destinos ao redor do mundo e posso encontrar
                  uma opção que combine com o que você procura.
                </p>
              </div>
              <a
                href={LINKS.cotacaoSite}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="missing-destination-btn"
                className="shrink-0 inline-flex items-center gap-2 rounded-full bg-white text-[#0055FE] font-semibold px-7 py-3.5 hover:bg-[#0B1120] hover:text-white transition-colors duration-300"
              >
                Quero fazer uma cotação
                <ArrowUpRight size={18} />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
